<markant-dialog
  [open]="true"
  [class.tour-finish-dialog]="showTourCompletedDialogContent"
  (close)="closeDialog()"
>
  @if (!showTourCompletedDialogContent) {
    <h4
      [innerHTML]="'guidedTour.sectionFinishedHeadline' | transloco"
      class="headline"
    ></h4>
    <img
      [ngSrc]="'assets/images/guided-tours/tour-section-finish.svg'"
      width="289"
      height="240"
      alt="Section finished image"
      class="section-finished-image"
    />
    <h2
      class="text"
      [innerHTML]="
        'guidedTour.sectionFinishedText'
          | transloco
            : {
                sectionNumber: sectionData.sectionNumber,
                sectionTitle,
              }
      "
    ></h2>
    <div class="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="backToDashboard()"
      >
        {{ 'guidedTour.backToDashboard' | transloco }}
      </markant-button>
      <markant-button
        class="next-section-button"
        colorScheme="primary"
        (click)="nextSection(sectionData.tourId, sectionData.sectionNumber)"
      >
        <markant-icon
          icon="m_arrow-right-small"
          slot="markant-button-icon-trailing"
        ></markant-icon>
        @if (sectionData.isLast) {
          {{ 'guidedTour.next' | transloco }}
        } @else {
          {{
            'guidedTour.goToSection'
              | transloco: { sectionNumber: sectionData.sectionNumber + 1 }
          }}
        }
      </markant-button>
    </div>
  } @else {
    <h2
      class="tour-finish-headline"
      [innerHTML]="'guidedTour.tourFinishedHeadline' | transloco: { tourTitle }"
    ></h2>
    <img
      [ngSrc]="'assets/images/guided-tours/tour-finish.svg'"
      width="326"
      height="253"
      alt="Tour finished image"
      class="tour-finished-image"
    />
    <h5 class="tour-finish-text">
      {{ 'guidedTour.tourFinishedText' | transloco }}
    </h5>
    <div class="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="removeWidget(sectionData.tourId)"
      >
        {{ 'guidedTour.tourFinishedButtons.deleteWidget' | transloco }}
      </markant-button>
      <markant-button (click)="keepWidget()">
        {{ 'guidedTour.tourFinishedButtons.keepWidget' | transloco }}
        <markant-icon
          icon="m_arrow-right-small"
          slot="markant-button-icon-trailing"
        ></markant-icon>
      </markant-button>
    </div>
  }
</markant-dialog>
